$(function() {
	// filter available products by default
	$('a').each(function() {
		var href = this.getAttribute('href');
		if (href.substring(0, 13) === '/collections/' && href.indexOf('filter.v.availability') == -1) {
			this.href = href + '?filter.v.availability=1';
		}
	});

	// open filters on mobile
//	const $filters = $('.filter-container.filter-container--show-filters-desktop .filters');
//	if ($filters.length && $filters.offset().left < 0) {
//		$('.toggle-btn--revealed-desktop').eq(0).trigger('click');
//	}
});
